import Icon from '@/components/atoms/Icon';

interface UploadEditorReadinessBannerProps {
  layoutsReady: boolean;
}

export default function UploadEditorReadinessBanner({ layoutsReady }: UploadEditorReadinessBannerProps) {
  if (layoutsReady) {
    return null;
  }

  const bannerText = 'Start editing while speaker detection, layouts, and AI content and more are being analysed.';

  return (
    <div className="flex w-full shrink-0 items-center gap-2 bg-orange-100 py-2.5 pl-8 pr-4 text-orange-600">
      <Icon name="IconLoader2" className="size-4 shrink-0 animate-spin" />
      <span className="text-xs font-medium leading-[18px]">{bannerText}</span>
    </div>
  );
}
